var styles = {"textLinkWrapper":"VBG__DS__text-link-module__2WVYj","bold":"VBG__DS__text-link-module__1EjU9"};

export { styles as default };
